
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'Flex',

	props: {
		center: { type: Boolean, default: false },
		justify: { type: String, default: 'flex-start' },
		align: { type: String, default: 'flex-start' } 
	}
})
